import React from 'react';
import {NavLink} from "react-router-dom";
import Status from "../../../pages/parcels/form_v3/status";
import CopyString from "../../../pages/parcels/form_v3/copyString";
import moment from "moment";
import {getRoles} from "../../../services/userRights";
import FieldModal from "../../Modals/FieldModal";
import NumberInput from "../../../controls/numberInput";
import {costFormat} from "../../../services/cost";

const Edit = ({col, row, reload, roles, withSync, inputComponent, label, canEdit}) => {
    let userRoles = getRoles();
    const editPermission = (!roles && canEdit) || userRoles.find(r => (roles || []).includes(r));

    return (
        editPermission ? <FieldModal
            label={label || `Изменить поле "${col.title}" для ${row.number}`}
            col={col}
            row={row}
            reload={reload}
            InputComponent={inputComponent}
            withSync={withSync}
        >
            <a className='copy-string__icon'>
                <span className="glyphicon glyphicon-pencil"></span>
            </a>
        </FieldModal> : null
    )
}

const TableCellValueGrid = ({column, row, gridName, canEditByRow, reload}) => {
    const editFields = {
        externalNumber: {
            withSync: true,
            label: `Изменить внешний номер посылки ${row.number}`
        },
        discountForCustomer: {
            inputComponent: NumberInput
        }
    }

    const cellType = (col) => {
        switch (col.type) {
            case 'date':
            case 'createdDate':
            case 'actualDeliveryDate':
            case 'actualDepartureDate':
            case 'deliveryDate':
            case 'departureDate':
            case 'statusChangedAt':
                return <div>
                    {
                        row[col.fieldName] ?
                            <span>{moment(row[col.fieldName]).format('DD.MM.YYYY')}, <span
                                className='color_grey'>{moment(row[col.fieldName]).format('HH:mm')}</span></span>
                            : null
                    }
                </div>
            case 'number':
                return <div>
                    {row.number && <NavLink style={{marginLeft: '5px'}} className='total__change-btn_name'
                                            to={"/parcels/" + row.id}>{row.number}</NavLink>}
                </div>;
            case 'linkToCard':
                return <div>
                    {row.id && <NavLink style={{marginLeft: '5px'}} className='total__change-btn_name'
                                        to={`/dictionary/${gridName}/${row.id}`}>{row[col.fieldName]}</NavLink>}
                </div>;
            case 'externalNumber':
                return row.externalNumber && <CopyString
                        text={row.externalNumber}
                        onClick={row.parcelUrl ? () => window.open(row.parcelUrl.replace('XXXX', row.externalNumber), '_blank') : true}
                    >
                        {row.externalNumber}
                    </CopyString>;
            case 'status':
                return <div style={{whiteSpace: 'nowrap'}}>
                    {row.status && <Status
                        name={row.status}
                        code={row.statusCode}
                    />}
                </div>
            case 'awardAgent':
            case 'profitPooling':
            case 'feeUsingYourCarrier':
            case 'costPrice':
            case 'discountForCustomer':
            case 'actualCostForAgent':
            case 'deliveryCost':
            case 'actualDeliveryCost':
                return row[col.fieldName] ? costFormat(Number.parseFloat(row[col.fieldName]).toFixed(2)) : ''
            case 'company':
                return row[col.type] || '';
            default:
                return row[col.fieldName] || ''
        }
    }

    const params = editFields[column.fieldName] || {};

    const canEdit = column.canEdit && (canEditByRow ? canEditByRow(column, row) : true);

    return <span>
        {cellType(column)}
        <Edit
            col={column}
            row={row}
            reload={reload}
            canEdit={canEdit}
            {...params}
        />
    </span>
};

export default TableCellValueGrid;


// WEBPACK FOOTER //
// ./App/components/Table/components/TableCellValueGrid.jsx